import { createRouteRef } from '@backstage/core-plugin-api';
import { SEAMLESS_PLUGIN_ID } from '@mercedes-benz/seamless-common';

export const rootRouteRef = createRouteRef({
  id: SEAMLESS_PLUGIN_ID,
});
